import React from 'react';
import ArrowLeftIcon from '@ingka/ssr-icon/paths/arrow-left';
import { ButtonTypeEnum } from 'ui/Button/Button';
import Box from 'ui/Box';
import { SpaceProps } from 'styled-system';
import { useIntl } from 'react-intl';
import Button from 'ui/Button/Button';

type Props = SpaceProps & {
  onClick: () => void;
  dataTestId: string;
};

const BackButton = ({ onClick, dataTestId, ...props }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Box {...props}>
      <Button
        dataTestId={dataTestId}
        type={ButtonTypeEnum.tertiary}
        onClick={onClick}
        ssrIcon={ArrowLeftIcon}
        aria-label={formatMessage({ id: 'storageone.back' })}
        iconOnly
      />
    </Box>
  );
};

export default BackButton;
